module.exports = __webpack_public_path__ + "img/2026-02-27c_1.4d195571.jpg";